export declare type MqttURL = `ws://${string}` | `wss://${string}`;

export const isMqttURL = ( value: unknown ): value is MqttURL => {
	return typeof value === "string" && ( value.startsWith("ws://") || value.startsWith("wss://") );
}
